export const Star = ({
  className,
  fill = 'rgba(0, 0, 0, 0.12)',
  ...svgProps
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      height="15"
      viewBox="0 0 16 15"
      width="16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33765 0L10.1338 5.52786H15.9461L11.2438 8.94427L13.0399 14.4721L8.33765 11.0557L3.63536 14.4721L5.43148 8.94427L0.729194 5.52786H6.54153L8.33765 0Z"
        fill={fill}
      />
    </svg>
  );
};
